import script from "./SelectAccId.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectAccId.vue?vue&type=script&setup=true&lang=js"

import "./SelectAccId.vue?vue&type=style&index=0&id=5df54def&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df54def"]])

export default __exports__